import React, { useEffect, useState } from "react";

const ErrorCirugia = ({setmodalOnErrorCirugia, quirofanoUserError, horaInicialUserError, horaFinalUserError, opcionUserError, codigoCirujanoCargoUserError, estadoPacienteError, errorFechaI, errorFechaF,errorDxPreoperatorio,errorDataQuirofanosOcupados,errorReservadoPor,dataHorariosQuirofanos}) => {
  const [fechaIni,setfechaIni] = useState('')
  const [fechaFin,setfechaFin] = useState('')
  const handleCancelarClick=()=>{
        setmodalOnErrorCirugia(false)
    }
    useEffect(()=>{
      if(errorDataQuirofanosOcupados.ProFec){
        setfechaIni(errorDataQuirofanosOcupados.ProFec.split(' ')[0])
      }
      if(errorDataQuirofanosOcupados.ProFecF){
        setfechaFin(errorDataQuirofanosOcupados.ProFecF.split(' ')[0])
      }
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto pt-20 bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md">
            <h5
              className="text-xl font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            ></h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>

          <div className="mt-3 text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-300">
              <svg fill="currentColor" viewBox="0 0 20 20" className="h-6 w-6">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <h3 className="text-lg leading-6 font-medium text-red-900">
              Error!
            </h3>
            <div className="mt-2 px-7 py-3">
                <ul>
                    <li className="text-lg text-red-500 text-left"> {quirofanoUserError}</li>
                    <li className="text-lg text-red-500 text-left"> {horaInicialUserError}</li>
                    <li className="text-lg text-red-500 text-left"> {horaFinalUserError}</li>
                    <li className="text-lg text-red-500 text-left"> {opcionUserError}</li>
                    <li className="text-lg text-red-500 text-left"> {codigoCirujanoCargoUserError}</li>
                    <li className="text-lg text-red-500 text-left"> {estadoPacienteError}</li>
                    <li className="text-lg text-red-500 text-left"> {errorFechaI}</li>
                    <li className="text-lg text-red-500 text-left"> {errorFechaF}</li>
                    <li className="text-lg text-red-500 text-left"> {errorDxPreoperatorio}</li>
                    
                    <li className="text-lg text-red-500 text-left"> {errorReservadoPor}</li>
                    <li className="text-lg text-red-500 text-left"> {errorDataQuirofanosOcupados?  `Sala ocupada para el rango de fechas digitado ${fechaIni} ${errorDataQuirofanosOcupados.ProHorI} a ${fechaFin} ${errorDataQuirofanosOcupados.ProHorF} con la Cirugía ${errorDataQuirofanosOcupados.ProCirCod}`    :null}</li>
                    <li className="text-lg text-red-500 text-left"> {dataHorariosQuirofanos.CoHSalQui !== ''?  `No se encuentra parametrización para el quirofano ${dataHorariosQuirofanos.idQuirofano} para el día ${dataHorariosQuirofanos.dia} en el rango de horario ${dataHorariosQuirofanos.CoHSalQui} a ${dataHorariosQuirofanos.CoHEntQui}`    :null}</li>
                    {/* <li className="text-lg text-red-500 text-left"> Sala ocupada para el rango de fechas digitado {errorDataQuirofanosOcupados? fechaIni : null} {errorDataQuirofanosOcupados? errorDataQuirofanosOcupados.ProHorI :null} a {errorDataQuirofanosOcupados? fechaFin : null} {errorDataQuirofanosOcupados? errorDataQuirofanosOcupados.ProHorF : null} con la Cirugía {errorDataQuirofanosOcupados? errorDataQuirofanosOcupados.ProCirCod : null}</li> */}
                </ul>
              {/* <p className="text-sm text-red-500">
                La información fue registrada con éxito!
              </p> */}
            </div>
            <div className="items-center px-4 py-3">
              <button
                type="button"
                onClick={handleCancelarClick}
                id="ok-btn"
                className="px-4 py-2 bg-red-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-300"
              >
                OK
              </button>
            </div>
          </div>
          {/* <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              //onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ErrorCirugia;
